import React from "react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
const PhoneKeyField = ({
  defaultValue,
  action,
  setPhoneNum,
  setExplicitField,
  phoneNum,
}) => {
  return (
    <PhoneInput
      className="phone-num-key"
      defaultCountry="iq"
      inputStyle={{ width: "100%" }}
      value={
        action === "update" && phoneNum.length < 1 ? defaultValue : phoneNum
      }
      onChange={(e) => {
        setPhoneNum(() => e);
      }}
      onBlur={() => setExplicitField("phoneNumber", true)}
    />
  );
};

export default PhoneKeyField;
